import ParseConfig from "@/api/parse.config.js";
import Parse from "parse";

export async function responseQuestionnaryResiliation(questionnaire, group) {
  try {
    ParseConfig();

    console.log("Début de la fonction responseQuestionnaryResiliation");
    console.log("Données du groupe:", group);

    // Définition des classes Parse
    const ObjectQuestionnaireResiliation = Parse.Object.extend("questionnaire_resiliation");
    const ObjectUserGroup = Parse.Object.extend("user_group");

    // Création des instances
    const questionnaireResiliation = new ObjectQuestionnaireResiliation();
    const queryUserGroup = new Parse.Query(ObjectUserGroup);

    const groupId = group.objectId || group.id;

    // Recherche du groupe utilisateur
    queryUserGroup.equalTo("objectId", groupId);
    const userGroup = await queryUserGroup.first();

    if (!userGroup) {
      throw new Error("Groupe utilisateur non trouvé");
    }

    console.log("Groupe utilisateur trouvé:", userGroup);

    // Configuration du questionnaire
    const questionnaireFields = {
      complexe: questionnaire.complexe || false,
      problemes_techniques: questionnaire.problemes_techniques || false,
      cout: questionnaire.cout || false,
      inutilise: questionnaire.inutilise || false,
    };

    // Définition des champs du questionnaire
    Object.entries(questionnaireFields).forEach(([key, value]) => {
      questionnaireResiliation.set(key, value);
    });

    // Gestion du champ "autre" et son texte
    if (questionnaire.autre) {
      questionnaireResiliation.set("autre", questionnaire.texte || "");
    }

    console.log("Questionnaire configuré:", questionnaireFields);

    // Association avec le groupe utilisateur
    questionnaireResiliation.set("group", userGroup);

    // Marquer le groupe comme résilié
    userGroup.set("resilie", true);

    // Ajout de la date de résiliation
    const dateResiliation = new Date();
    userGroup.set("dateResiliation", dateResiliation);
    console.log("Date de résiliation définie:", dateResiliation);

    // Sauvegarde des modifications
    await Parse.Object.saveAll([userGroup, questionnaireResiliation]);

    console.log("Questionnaire et groupe utilisateur sauvegardés avec succès");

    return {
      success: true,
      questionnaire: questionnaireResiliation,
      userGroup: userGroup,
    };

  } catch (error) {
    console.error("Erreur lors de la résiliation:", error);
    throw error;
  }
}